
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 18V6a2 2 0 00-2-2h-5a2 2 0 00-2 2v12a2 2 0 002 2h5a2 2 0 002-2zM9 20H4a2 2 0 01-2-2V6a2 2 0 012-2h5a2 2 0 012 2v12a2 2 0 01-2 2z","fill-rule":"evenodd"}})])
          )
        }
      }
    